<template>
	<div id="introduction-container" class="center-text-container">
		<div id="introduction-headliner" class="landing-red content-maintext regular-text">
			{{headline}}
		</div>

		<div id="introduction-text" class="content-subtext light-text">
			{{headText}}
		</div>

		<router-link to="contact">
			<button class="flat-button-white content-description light-text" @click="linkTo()">
				{{buttonText}}
			</button>
		</router-link>
	</div>
</template>



<script>
	export default {
		name: 'LandingIntroduction',
		props: ['headline', 'headText'],
		data: 
			function(){ 
				return {
//					headline: "CIB+",
//					headText: "Einfache, abgesicherte und schnelle Immobilienbewertung",
//                                      headText: this.landingStartData[0].headline,
					buttonText: "KONTAKT",
				}
			},
			
		methods: {
			linkTo() {
				this.$emit('contactEvent');
			}
		}
}

</script>

<style scoped>
	#introduction-container {
		margin-bottom: 12em;
		margin-top: 4em;
		
	}

	#introduction-headliner {
		margin-bottom: 0.5em;
	}

	#introduction-text {
		margin-bottom: 1em;
		
	}
	
	@media (max-width: 991px) {
		#introduction-container {
			margin-top: 2em;
		}
	}
	@media (max-width: 767px) {
		#introduction-container {
		margin-bottom: 5em;
		margin-top: 2.5em;
	}
}

	@media (max-width: 575px) {
		#introduction-container {
		margin-bottom: 3em;
		margin-top: 55vw;
	}
}

</style>


